import '../../common/css/style.css';

// Вартість занять/абонементів
// • Пакети послуг (групові, індивідуальні)
// • Спеціальні пропозиції або знижки

export const Prices = () => {
  return (
    <div id="prices" className="main-style">
      <div className="container-wrapper">
        <section className="container">
          <h2 className="container-title">Вартість 💳</h2>

          <section className="container-block">
            <h3 className="container-heading">Абонементи</h3>
            <ul className="feature-list">
              <li>💃 Групові заняття — абонемент на 8 занять на місяць</li>
              <li>🧍 Індивідуальні заняття — погодинна оплата, графік під клієнта</li>
              <li>👯 Пробне заняття — щоб спокійно оцінити, чи підходить саме вам</li>
            </ul>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Напрямки</h3>
            <ul className="feature-list">
              <li>👶 Групи для наймолодших</li>
              <li>🕺 Спортивно-бальні програми</li>
              <li>🎓 Підготовка до конкурсів та виступів</li>
            </ul>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Знижки</h3>
            <ul className="feature-list">
              <li>👨‍👩‍👧 Знижка, якщо студію відвідують кілька дітей з однієї сімʼї</li>
              <li>🎉 Спеціальні пропозиції під час набору нових груп</li>
            </ul>
          </section>

          <p>
            💬 Назвемо точну вартість і актуальні акції за кілька хвилин —
            просто напишіть чи зателефонуйте.
          </p>

          <a href="/#contacts" className="cta-link">
            Дізнатись вартість <span aria-hidden="true">→</span>
          </a>
        </section>
      </div>
    </div>
  );
};
